import React, {useState, useEffect} from 'react'
import './back.css'

const BackToTop = () => {
        const[backToTop, setBackToTop] = useState(false) 

        useEffect(() => {
          window.addEventListener('scroll', () => {
              if(window.scrollY > 100){
                  setBackToTop(true)
              }else{
                  setBackToTop(false)
              }
          })
        }, [])

        const scrollUp = () => {
            window.scrollTo ({
                top: 0,
            behavior: 'smooth'
            })
        }
        
  return (
    <div className='fixed bottom-5 right-3 z-50'>
        {backToTop && <div onClick={scrollUp} className='backToTop flex justify-center items-center w-[50px] h-[50px] rounded-full bg-white  font-bold '><span>Top</span></div>}
    </div>
  )
}

export default BackToTop